import React, { useState } from "react";
import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";

const ContactMethods = () => {
  const [selectedCategory, setSelectedCategory] = useState("general");

  const contactMethods = [
    {
      icon: "Phone",
      title: "Call Us",
      description: "Speak directly with our team",
      value: "(508) 980-5187",
      action: "Call Now",
      available: "9 AM - 7 PM EST",
      color: "text-blue-600",
    },
    {
      icon: "Mail",
      title: "Email Us",
      description: "Get detailed project information",
      value: "hello@skycreststudios.com",
      action: "Send Email",
      available: "Response within 2 hours",
      color: "text-green-600",
    },
    {
      icon: "MessageCircle",
      title: "Live Chat",
      description: "Instant support and quotes",
      value: "Chat with our team",
      action: "Start Chat",
      available: "Online now",
      color: "text-purple-600",
    },
  ];

  const categories = [
    { id: "general", name: "General Inquiry", icon: "HelpCircle" },
    { id: "wedding", name: "Wedding & Events", icon: "Heart" },
    { id: "realestate", name: "Real Estate", icon: "Home" },
    { id: "marketing", name: "Marketing", icon: "Megaphone" },
    { id: "design", name: "Design Fiction", icon: "Zap" },
  ];

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-fluid-3xl font-display font-bold text-primary mb-4">
              Multiple Ways to Connect
            </h2>
            <p className="text-fluid-lg text-muted-foreground max-w-2xl mx-auto">
              Choose the communication method that works best for you. We're
              here to help bring your vision to life.
            </p>
          </div>

          {/* Category Selection */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {categories?.map((category) => (
              <button
                key={category?.id}
                onClick={() => setSelectedCategory(category?.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium transition-smooth ${
                  selectedCategory === category?.id
                    ? "bg-accent text-accent-foreground"
                    : "bg-muted text-muted-foreground hover:bg-accent/20"
                }`}
              >
                <Icon name={category?.icon} size={16} />
                <span>{category?.name}</span>
              </button>
            ))}
          </div>

          {/* Contact Methods Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {contactMethods?.map((method, index) => (
              <div
                key={index}
                className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-smooth hover-lift"
              >
                <div
                  className={`inline-flex items-center justify-center w-12 h-12 rounded-lg bg-muted mb-4 ${method?.color}`}
                >
                  <Icon name={method?.icon} size={24} />
                </div>

                <h3 className="text-lg font-semibold text-card-foreground mb-2">
                  {method?.title}
                </h3>

                <p className="text-sm text-muted-foreground mb-3">
                  {method?.description}
                </p>

                <p className="text-sm font-medium text-foreground mb-2">
                  {method?.value}
                </p>

                <p className="text-xs text-muted-foreground mb-4">
                  {method?.available}
                </p>

                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  iconName={method?.icon}
                  iconPosition="left"
                >
                  {method?.action}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;
